export default __webpack_public_path__ + "static/media/beauty.be19f897.png";